import React from "react";
import ReactDOM from "react-dom";
// import "./index.css";
import App from "./components/App";
// import "rsuite/dist/styles/rsuite-default.css";

import { BrowserRouter as Router } from "react-router-dom";

import ColorModeProvider from "./context/ColorModeProvider";
import { SitesProvider } from "./context/SiteProvider";
import { WallsProvider } from "./context/WallProvider";
import { UserProvider } from "./context/UserProvider";
import { ConfirmProvider } from "material-ui-confirm";

ReactDOM.render(
  <UserProvider>
    <ColorModeProvider>
      <SitesProvider>
        <WallsProvider>
          <ConfirmProvider>
            <React.StrictMode>
              <Router>
                <App />
              </Router>
            </React.StrictMode>
          </ConfirmProvider>
        </WallsProvider>
      </SitesProvider>
    </ColorModeProvider>
  </UserProvider>,

  document.getElementById("root")
);
